(function () {
    'use strict';
    var controllerId = 'risorsaAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', risorsaAdd]);

    function risorsaAdd($scope, $uibModalInstance, datacontext, common) {
        $scope.risorsa = {};
        $scope.getSocieta = getSocieta;
        $scope.societa = [];
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');

        $scope.ok = function (isValid) {            
        	if (isValid) {
        	    addItem($scope.risorsa).then(function (result) {
        	        if (result == '502') logError('Username gi&agrave; registrata');
        	        else if (!result || result.Id == null || result.Id == 0) $uibModalInstance.close(null);
        	        else $uibModalInstance.close(result);
        	    });
        	}
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.suggest = function () {
            if (!$scope.risorsa.Nome || !$scope.risorsa.Cognome)
                return;

            datacontext.user_suggestUserame($scope.risorsa.Nome, $scope.risorsa.Cognome).then(function (username) {
                if (!username || username.trim().length == 0)
                    return;

                $scope.risorsa.Username = username;

                datacontext.user_suggestPassword($scope.risorsa.Nome).then(function (password) {
                    if (!password || password.trim().length == 0)
                        return;

                    $scope.risorsa.Password = password;
                });
            });
        };

        function addItem(item) {
            return datacontext.risorsa_add(item).then(function (data) {        	    
        		return data;
        	});
        }

        // funzione che permette di visualizzare l'[id] RagioneSociale (Comune) della societ� e non l'id
        $scope.formatLabelSocieta = function (model) {
            for (var i = 0; i < $scope.societa.length; i++) {
                if (model === $scope.societa[i].Id) {
                    $scope.risorsa.Societa = '[' + $scope.societa[i].Id + ']' + ' ' + $scope.societa[i].RagioneSociale + ' ' + '(' + $scope.societa[i].Comune + ')';
                    return $scope.risorsa.Societa;
                }
            }
        };

        function getSocieta(ricerca) {

            $scope.risorsa.SocietaId = ricerca;
            return datacontext.societa_getAllByFilter($scope.risorsa.SocietaId, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    $scope.societa = data;
                    return $scope.societa;
                }
                return null;
            });
        }
    }
})();